import React from "react";
import "./shopnow.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { HiMiniArrowLongRight } from "react-icons/hi2";

// import "./style.css"

const ShopNow = ({ data, div }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      {data.map((value, index) => (
        <div class={`product-block block ${div}`}>
          <div key={index} class="box">
            <p class="btn-default">{value.btnname} </p>
            <div class="over">
              <div class="holder">
                <div class="align-left">
                  <Link to="/product" onClick={scrollToTop} className="flex group">
                    {" "}
                    <strong class="title-name">{value.titlename}</strong>{" "}
                    <HiMiniArrowLongRight className="text-2xl text-white ml-1 transition-transform duration-300 transform group-hover:translate-x-2" />
                    
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <img class="responsive-image" alt="products" src={value.img} />
        </div>
      ))}
    </>
  );
};

export default ShopNow;
